/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import configuration */
import { APP_ROUTES } from '@/config/appRoutes';

const DASHBOARD_PATH_PREFIXES = [
    APP_ROUTES.overview,
    APP_ROUTES.statistics,
    APP_ROUTES.thermalconflict,
    APP_ROUTES.pricetrafficlight,
];
const DASHBOARD_DETAIL_PATH_PREFIXES = [
    APP_ROUTES.pvprediction,
    APP_ROUTES.waterloss,
    APP_ROUTES.baseload,
    APP_ROUTES.heatingenergy,
];
const SYSTEM_DASHBOARD_PATH_PATTERN = new RegExp(`^${APP_ROUTES.systems}/[^/]+$`);
const SYSTEM_STATISTICS_PATH_PATTERN = new RegExp(`^${APP_ROUTES.systems}/[^/]+/statistics(?:/|$)`);
const SYSTEM_ANOMALY_DETAIL_PATH_PATTERN = new RegExp(
    `^${APP_ROUTES.systems}/[^/]+/(?:pv-prediction|base-load|heating-energy|water)/[^/]+$`,
);

/**
 * Identifies system paths that require the fullscreen dashboard shell.
 */
export function isSystemDashboardPath(pathname: string): boolean {
    return SYSTEM_DASHBOARD_PATH_PATTERN.test(pathname)
        || SYSTEM_STATISTICS_PATH_PATTERN.test(pathname)
        || SYSTEM_ANOMALY_DETAIL_PATH_PATTERN.test(pathname);
}

/**
 * Identifies every route that needs the constrained dashboard layout and its scroll handling.
 */
export function isDashboardPagePath(pathname: string): boolean {
    return DASHBOARD_PATH_PREFIXES.some((pathPrefix) => (
        pathname === pathPrefix || pathname.startsWith(`${pathPrefix}/`)
    ))
        || isSystemDashboardPath(pathname)
        || DASHBOARD_DETAIL_PATH_PREFIXES.some((pathPrefix) => pathname.startsWith(`${pathPrefix}/`));
}
